<template>
    <div class="tqList TQ_margin_4px TQ_grid_center">

        <div class="img-grid TQ_grid_center">
            <slot name="img"/>
        </div>

        <div class="title TQ_grid_center">
            <slot name="title"/>
        </div>

        <div class="description TQ_grid_center">
            <slot name="description"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TqList",
    }
</script>

<style scoped lang="scss">

    .tqList{
        display: grid;
        grid-template-columns:auto 1fr ;
        grid-template-rows: auto 1fr;
        grid-template-areas:
                "img-grid title"
                "img-grid description";
        grid-column-gap: 16px;
        background: white;
        /*max-height: 64px;*/

        .img-grid {
            grid-area: img-grid;
        }

        .title {
            grid-area: title;
            align-self: center;
            /*justify-self: center;*/
        }

        .description {
            grid-area: description;
            /*align-self: ;*/

            /*max-height: 20px;*/
            /*overflow: hidden;*/
        }

    }




</style>